import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-bottom-nav',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  template: `
    <nav class="fixed inset-x-0 bottom-0 z-50 print:hidden border-t border-white/[0.06] bg-[rgba(17,17,20,0.96)] px-2 pb-[env(safe-area-inset-bottom,0px)] backdrop-blur-xl">
      <div class="mx-auto flex h-[68px] max-w-2xl items-center justify-around px-1">
        <a
          routerLink="/dashboard"
          routerLinkActive
          [routerLinkActiveOptions]="{ exact: true }"
          #dashboardRla="routerLinkActive"
          class="group flex h-full flex-1 flex-col items-center justify-center transition-all duration-200 ease-out active:scale-95 text-gray-600 hover:text-gray-400"
        >
          <div class="relative">
            <div
              [class]="dashboardRla.isActive
                ? 'flex h-10 w-10 items-center justify-center rounded-full transition-all duration-200 bg-[color:var(--color-app-primary)] text-white shadow-[0_8px_18px_rgba(180,149,92,0.28)]'
                : 'flex h-10 w-10 items-center justify-center rounded-full transition-all duration-200 bg-transparent'"
            >
              <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M3 10.5L12 3L21 10.5V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V10.5Z" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round"/>
                <path d="M9 21V14H15V21" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round"/>
              </svg>
            </div>
            @if (dashboardRla.isActive) {
              <div class="absolute -bottom-0.5 left-1/2 h-1 w-1 -translate-x-1/2 rounded-full bg-[color:var(--color-app-primary)]"></div>
            }
          </div>
          <span [class]="dashboardRla.isActive ? 'mt-0.5 text-[10px] font-medium tracking-wide text-[color:var(--color-app-primary)]' : 'mt-0.5 text-[10px] font-medium tracking-wide'">Dashboard</span>
        </a>

        <a
          routerLink="/vehicles"
          routerLinkActive
          [routerLinkActiveOptions]="{ exact: true }"
          #vehiclesRla="routerLinkActive"
          class="group flex h-full flex-1 flex-col items-center justify-center transition-all duration-200 ease-out active:scale-95 text-gray-600 hover:text-gray-400"
        >
          <div class="relative">
            <div
              [class]="vehiclesRla.isActive
                ? 'flex h-10 w-10 items-center justify-center rounded-full transition-all duration-200 bg-[color:var(--color-app-primary)] text-white shadow-[0_8px_18px_rgba(180,149,92,0.28)]'
                : 'flex h-10 w-10 items-center justify-center rounded-full transition-all duration-200 bg-transparent group-hover:bg-white/[0.06]'"
            >
              <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M5 14L7 9H17L19 14M7 14H17M7 14V17C7 17.5523 6.55228 18 6 18H5C4.44772 18 4 17.5523 4 17V15C4 14.4477 4.44772 14 5 14H7ZM17 14H19C19.5523 14 20 14.4477 20 15V17C20 17.5523 19.5523 18 19 18H18C17.4477 18 17 17.5523 17 17V14Z" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"/>
                <circle cx="7.5" cy="15.5" r="1" fill="currentColor"/>
                <circle cx="16.5" cy="15.5" r="1" fill="currentColor"/>
              </svg>
            </div>
            @if (vehiclesRla.isActive) {
              <div class="absolute -bottom-0.5 left-1/2 h-1 w-1 -translate-x-1/2 rounded-full bg-[color:var(--color-app-primary)]"></div>
            }
          </div>
          <span [class]="vehiclesRla.isActive ? 'mt-0.5 text-[10px] font-medium tracking-wide text-[color:var(--color-app-primary)]' : 'mt-0.5 text-[10px] font-medium tracking-wide'">Vehicles</span>
        </a>

        <a
          routerLink="/clients"
          routerLinkActive
          [routerLinkActiveOptions]="{ exact: true }"
          #clientsRla="routerLinkActive"
          class="group flex h-full flex-1 flex-col items-center justify-center transition-all duration-200 ease-out active:scale-95 text-gray-600 hover:text-gray-400"
        >
          <div class="relative">
            <div
              [class]="clientsRla.isActive
                ? 'flex h-10 w-10 items-center justify-center rounded-full transition-all duration-200 bg-[color:var(--color-app-primary)] text-white shadow-[0_8px_18px_rgba(180,149,92,0.28)]'
                : 'flex h-10 w-10 items-center justify-center rounded-full transition-all duration-200 bg-transparent group-hover:bg-white/[0.06]'"
            >
              <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M16 19V17C16 15.8954 15.1046 15 14 15H6C4.89543 15 4 15.8954 4 17V19" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/>
                <circle cx="10" cy="9" r="3" stroke="currentColor" stroke-width="1.9"/>
                <path d="M20 19V17C20 16.0672 19.3625 15.2835 18.5 15.0605" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/>
                <path d="M15.5 6.06055C16.3647 6.28243 17 7.06611 17 8C17 8.93389 16.3647 9.71757 15.5 9.93945" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/>
              </svg>
            </div>
          </div>
          <span [class]="clientsRla.isActive ? 'mt-0.5 text-[10px] font-medium tracking-wide text-[color:var(--color-app-primary)]' : 'mt-0.5 text-[10px] font-medium tracking-wide'">Members</span>
        </a>

        <a
          routerLink="/reservations"
          routerLinkActive
          #reservationsRla="routerLinkActive"
          class="group flex h-full flex-1 flex-col items-center justify-center transition-all duration-200 ease-out active:scale-95 text-gray-600 hover:text-gray-400"
        >
          <div class="relative">
            <div
              [class]="reservationsRla.isActive
                ? 'flex h-10 w-10 items-center justify-center rounded-full transition-all duration-200 bg-[color:var(--color-app-primary)] text-white shadow-[0_8px_18px_rgba(180,149,92,0.28)]'
                : 'flex h-10 w-10 items-center justify-center rounded-full transition-all duration-200 bg-transparent group-hover:bg-white/[0.06]'"
            >
              <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <rect x="5" y="4" width="14" height="17" rx="2" stroke="currentColor" stroke-width="1.9"/>
                <path d="M9 4V3H15V4" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/>
                <path d="M9 10H15M9 13.5H15M9 17H13" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/>
              </svg>
            </div>
            @if (reservationsRla.isActive) {
              <div class="absolute -bottom-0.5 left-1/2 h-1 w-1 -translate-x-1/2 rounded-full bg-[color:var(--color-app-primary)]"></div>
            }
          </div>
          <span [class]="reservationsRla.isActive ? 'mt-0.5 text-[10px] font-medium tracking-wide text-[color:var(--color-app-primary)]' : 'mt-0.5 text-[10px] font-medium tracking-wide'">Reservations</span>
        </a>

        <a
          routerLink="/notifications"
          routerLinkActive
          [routerLinkActiveOptions]="{ exact: true }"
          #notificationsRla="routerLinkActive"
          class="group flex h-full flex-1 flex-col items-center justify-center transition-all duration-200 ease-out active:scale-95 text-gray-600 hover:text-gray-400"
        >
          <div class="relative">
            <div
              [class]="notificationsRla.isActive
                ? 'flex h-10 w-10 items-center justify-center rounded-full transition-all duration-200 bg-[color:var(--color-app-primary)] text-white shadow-[0_8px_18px_rgba(180,149,92,0.28)]'
                : 'flex h-10 w-10 items-center justify-center rounded-full transition-all duration-200 bg-transparent group-hover:bg-white/[0.06]'"
            >
              <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M3 7.5L7.5 3H16.5L21 7.5V16.5C21 17.3284 20.3284 18 19.5 18H4.5C3.67157 18 3 17.3284 3 16.5V7.5Z" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3 7.5H21" stroke="currentColor" stroke-width="1.9"/>
                <path d="M12 11V16" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/>
                <path d="M9 13.5L12 16.5L15 13.5" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            @if (notificationsRla.isActive) {
              <div class="absolute -bottom-0.5 left-1/2 h-1 w-1 -translate-x-1/2 rounded-full bg-[color:var(--color-app-primary)]"></div>
            }
          </div>
          <span [class]="notificationsRla.isActive ? 'mt-0.5 text-[10px] font-medium tracking-wide text-[color:var(--color-app-primary)]' : 'mt-0.5 text-[10px] font-medium tracking-wide'">Notify</span>
        </a>

        <a
          routerLink="/more"
          routerLinkActive
          [routerLinkActiveOptions]="{ exact: true }"
          #moreRla="routerLinkActive"
          class="group flex h-full flex-1 flex-col items-center justify-center transition-all duration-200 ease-out active:scale-95 text-gray-600 hover:text-gray-400"
        >
          <div class="relative">
            <div
              [class]="moreRla.isActive
                ? 'flex h-10 w-10 items-center justify-center rounded-full transition-all duration-200 bg-[color:var(--color-app-primary)] text-white shadow-[0_8px_18px_rgba(180,149,92,0.28)]'
                : 'flex h-10 w-10 items-center justify-center rounded-full transition-all duration-200 bg-transparent group-hover:bg-white/[0.06]'"
            >
              <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <circle cx="5" cy="12" r="1.8" fill="currentColor"/>
                <circle cx="12" cy="12" r="1.8" fill="currentColor"/>
                <circle cx="19" cy="12" r="1.8" fill="currentColor"/>
              </svg>
            </div>
          </div>
          <span [class]="moreRla.isActive ? 'mt-0.5 text-[10px] font-medium tracking-wide text-[color:var(--color-app-primary)]' : 'mt-0.5 text-[10px] font-medium tracking-wide'">More</span>
        </a>
      </div>
    </nav>
  `,
})
export class BottomNavComponent {}
